import filterDataReducer, {
    actions as filterDataActions,
} from '../filterData';
import * as filterActions from './actions';
import * as selectors from './selectors';

const actions = {
    ...filterDataActions,
    ...filterActions,
};
export {
    actions,
    selectors,
};

export default filterDataReducer;
